import Reveal from '@/components/base/Reveal';
import { guideSteps } from '@/mocks/homeData';

function GuideSteps() {
  return (
    <section className="w-full bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-6xl">
          <Reveal>
            <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
              <div>
                <span className="inline-flex items-center gap-1.5 text-xs font-label text-foreground-500 uppercase tracking-widest">
                  <i className="ri-guide-line" />
                  How To Browse
                </span>
                <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
                  三步逛明白黑料网社
                </h2>
              </div>
              <p className="max-w-md text-sm md:text-base text-foreground-600 font-label leading-relaxed">
                新用户按顺序走一遍，基本就把黑料网社的分区结构和入口逻辑摸清了。
              </p>
            </div>
          </Reveal>

          <div className="mt-9 grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
            {guideSteps.map((item, index) => (
              <Reveal key={item.step} delay={index * 70}>
                <div className="relative h-full rounded-lg border border-background-200 bg-background-100 p-6 md:p-7">
                  <span className="absolute top-5 right-6 font-heading text-4xl font-bold text-background-300 select-none">
                    {item.step}
                  </span>
                  <span
                    className={`flex items-center justify-center w-12 h-12 rounded-md text-2xl ${
                      index === 1
                        ? 'bg-accent-500 text-foreground-950'
                        : index === 2
                          ? 'bg-secondary-500 text-background-50'
                          : 'bg-primary-500 text-background-50'
                    }`}
                  >
                    <i className={item.icon} />
                  </span>
                  <h3 className="mt-5 font-heading text-lg font-bold text-foreground-950">{item.title}</h3>
                  <p className="mt-2 text-sm font-label text-foreground-600 leading-relaxed">{item.desc}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default GuideSteps;